module.exports = __webpack_public_path__ + "img/fgz.674aca3a.svg";